import { Param } from './../../../model/common/param';
import { Component, ViewChild } from '@angular/core';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { saveAs as fileSaveAs } from 'file-saver-es';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Brand } from '../../../model/api/assets/brand';
import { BrandList } from './brand.list';
import { BrandDetail } from './brand.detail';
import { BrandHttpService } from '../../../services/http/assets/brand.http.service';

@Component({
    selector: 'brand-manage',
    templateUrl: 'brand.manage.html',
})
export class BrandManage extends GenericManage<Brand, number> {

    @ViewChild('brandDetailModal') brandDetailModal: ModalDirective;
    @ViewChild('brandList') brandList: BrandList;
    @ViewChild('brandDetail') brandDetail: BrandDetail;

    public filter: string = '';
    isCollapsed: boolean = true;
    constructor(
        public brandHttpService: BrandHttpService) {
        super();
    }

    public addNewItem() {
        super.addNewItem();
    }

    public editItem() {
        super.editItem();
    }

    public detailInitialize() {
        super.detailInitialize();
        this.brandDetailModal.show();
    }

    public detailTerminate() {
        super.detailTerminate();
        this.brandDetailModal.hide();
    }


    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));

        this.brandList.refresh(params);
    }


    // public exportToExcel(){

    //      let params: Array<Param> = null;

    //     if ((this.filter != null) && (this.filter.length > 0)) {
    //         params = new Array<Param>();
    //         params.push(new Param('filter', this.filter));
    //     }

    //     this.locationHttpService.get(1, 10000000, 'code', 'asc', params, null).subscribe(
    //         (data: PagedResult<Location>) => {

    //             let options = {
    //                 sheetid: 'Buildings',
    //                 headers: true,
    //                 column: { style: { Font: { Bold: '1' } } },
    //                 rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
    //                 cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
    //             };

    //             alasql(`SELECT id as [Id],
    //                 code as [Cod],
    //                 name as [Denumire],
    //                 region->name as [Judet],
    //                 admCenter->name as [Regiune]
    //                 INTO XLSX("Buildings.xlsx",?) FROM ?`, [ options, data.items ]);

    //         });

    // }

    public getFilters(): Array<Param> {
        let params: Array<Param> = new Array<Param>();
        params.push(new Param('filter', this.filter));

        return params;
    }

    public exportToExcel() {

        let params: Array<Param> = null;

        params = this.getFilters();
        this.brandHttpService
            .export(params)
            .subscribe((blob) => {
                fileSaveAs(blob, 'brands.xlsx');
            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
